import en from 'vuetify/es5/locale/en'

export default {
    ...en,

    tvsm: {
        loginfailcode: {
            1: 'This user is not registered.',
            2: 'User authentication failed.'
        },
        next: 'next',
        language: 'English',
        gendershort: { 1: 'M', 2: 'F' },
        gender: { 1: 'Male', 2: 'Female' },
        usertype: {1:'Admin', 2:'Physician', 3:'Staff'},
        pattype: {1:'New Born', 2:'Pediatric', 3:'Adult'},
        menu: {
            tvsmList: 'TVSM List',

            history: 'History',
            videoCallHistory: 'Videocall',
            videoCallReservationHistory: 'Reservation',

            management: 'Management',
            group: 'Group',
            user: 'User',
            patient: 'Patient',
            device: 'Device',

            realtime: 'Realtime'
        },
        header: {
            seq: 'Seq.',
            status: 'Status',
            group: 'Group',
            deviceName: 'Device Name',
            patientNameAndId: 'Patient ID/Name',
            patientStatus: 'Patient Status',
            birthday: 'Birthday',
            ageSexBloodType: 'Age/Sex/Blood Type',
            heightWeight: 'Height/Weight',
            detail: 'Detail',

            userName: 'Physician',
            patientName: 'Patient',
            startTime: 'Start',
            endTime: 'End',
            duration: 'Duration',

            requestTime: 'Requested',
            requestType: 'Type',
            reserveTime: 'Reserved',
            videocall: 'Videocall'
        },
        alert: {
            noConnection: 'No connection.'
        }
    },

    common: {
        search: 'SEARCH',
        login: 'Login',
        logout: 'Logout',
        cancel: 'Cancel',
        submit: 'Submit',
        updated: 'Updated',
        created: 'Created',
        deleted: 'Deleted',
        start: 'Start',
        addGroup: 'Add Group',
        noMemo: 'No Memo',
        update: 'Edit',
        delete: 'Delete',
        memo: 'Memo',
        groupName: 'Group Name',
        confirmDelete: 'Delete Group "{0}"?',
        editDelete: 'Edit/Delete',
        addPatient: 'Add Patient',
        ID: 'ID',
        name: 'Name',
        type: 'Type',
        age: 'Age',
        sex: 'Sex',
        bloodType: 'Blood Type',
        height: 'Height',
        weight: 'Weight',
        addUser: 'Add User',
        pacemaker: 'Pace maker',
        phone: 'Phone',
        email: 'Email',
        remoteControl: 'Access',
        modelName: 'Model',
        lastUpdated: 'Last Updated',
        requestType: {
            1: 'Normal',
            2: 'Emergency'
        },

        menu: {
            account: 'My Account'
        }
    }
}